import React, { memo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Stack, Button, Icon, TextField, Select, MenuItem } from 'investira.react.components';
import { BaseTemplate } from '../../../components/templates';
import withMessage from '../../../hoc/withMessage';

const ALFABETO_OPTIONS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

const AvaliacoesSettingsSecaoEdit = memo(props => {
  const navigate = useNavigate();

  const [titulo, setTitulo] = useState('');
  const [alias, setAlias] = useState('');
  const [descricao, setDescricao] = useState('');

  const handleSave = () => {
    if (!titulo.trim()) {
      props.onMessageError?.('Informe o título da sessão.');
      return;
    }

    if (!alias.trim()) {
      props.onMessageError?.('Informe o alias da sessão.');
      return;
    }

    const xPayload = {
      titulo: titulo.trim(),
      alias: alias.trim(),
      descricao: descricao.trim()
    };

    console.log('nova seção', xPayload);
    props.onMessageSuccess?.('Seção criada com sucesso.');
    navigate('/avaliacoes/configuracoes/secoes');
  };

  return (
    <BaseTemplate
      title={'Editar Seção'}
      subtitle={'Configurações'}
      description="Informe o objetivo e a finalidade desta sessão para organizar e estruturar melhor os critérios da avaliação."
      maxWidth={'md'}
      headerRenderActions={
        <Stack direction="row" spacing={2}>
          <Button
            disabled={props.disabledButtons}
            variant="contained"
            color="primary"
            startIcon={<Icon iconName="upload" size={16} />}
            size="small"
            sx={{ px: 2 }}
            onClick={handleSave}>
            Salvar
          </Button>
        </Stack>
      }>
      <Stack gap={2} py={3}>
        <Stack direction="row" gap={2} alignItems="flex-start">
          <Stack flex={1}>
            <TextField
              label="Título"
              placeholder="Ex.: Análise Fundamentalista"
              value={titulo}
              onChange={pEvent => setTitulo(pEvent.target.value)}
              fullWidth
              InputLabelProps={{ shrink: true }}
              variant="outlined"
            />
          </Stack>

          <Stack sx={{ width: '120px' }}>
            <Select
              value={alias}
              onChange={pEvent => setAlias(pEvent.target.value)}
              fullWidth
              displayEmpty>
              <MenuItem value="" disabled>
                Alias
              </MenuItem>
              {ALFABETO_OPTIONS.map(xLetra => {
                return (
                  <MenuItem key={xLetra} value={xLetra}>
                    {xLetra}
                  </MenuItem>
                );
              })}
            </Select>
          </Stack>
        </Stack>

        <TextField
          label="Descrição"
          placeholder="Descreva o objetivo desta sessão"
          value={descricao}
          onChange={pEvent => setDescricao(pEvent.target.value)}
          fullWidth
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          multiline
          rows={4}
        />
      </Stack>
    </BaseTemplate>
  );
});

AvaliacoesSettingsSecaoEdit.displayName = 'AvaliacoesSettingsSecaoEdit';

export default withMessage(AvaliacoesSettingsSecaoEdit);
